import { runDemo } from "../shared/demoRunner";
import { createDancersScene } from "./scene";

runDemo({ createScene: createDancersScene });
